module.exports = __webpack_public_path__ + "static/media/mapnode-laufen-premium.48c31b72.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/styles/assets/mapnode-laufen-premium.svg
// module id = 309
// module chunks = 0